export const API_URL = "https://api.grupok1.com.br/v3/";
export const API_URLDEV = "https://grupok1api.grupok1.com.br/v3/";
export const API_TIMEOUT = 15000;
export const COOKIE_TIMEOUT = "20min";
export const COOKIE_DEVTIMEOUT = "1D";
export const COOKIE_ANONIMOUSTOKEN = "1D";
export const API_MODEL = {
  success: false,
  apiresponse: {
    Success: "False",
    Error: [],
    Data: [],
  },
};
